import type { Patient } from '@medplum/fhirtypes'
import { MessagesPageFullView, MessagesPageMinimizedView } from './components'
import { useMessagesPageState } from './useMessagesPageState'

export const MessagesPage = ({
  showMinimizedView,
  preselectedPatient,
  focusThreadId,
  onClose,
}: {
  showMinimizedView?: boolean
  preselectedPatient?: Patient | null
  focusThreadId?: string | null
  onClose?: () => void
}) => {
  const controller = useMessagesPageState(preselectedPatient)

  if (showMinimizedView) {
    return (
      <MessagesPageMinimizedView
        controller={controller}
        focusThreadId={focusThreadId}
        onClose={onClose}
      />
    )
  }

  return <MessagesPageFullView controller={controller} />
}
